/**
 * tb-cart-custom.js — ThermalBros Cart Enhancements
 * Handles:
 *   1. Order Protection (insurance)
 *   2. Free Items (hat + shirt)
 *   3. Checkout gate for required free selections
 */

(function () {
  'use strict';

  const log = (...args) => {
    if (window.Shopify && window.Shopify.designMode) console.log('[TB Cart]', ...args);
  };

  const TB_CART_URLS = {
    cart: window.routes?.cart_url || '/cart',
    add: window.routes?.cart_add_url || '/cart/add.js',
    change: window.routes?.cart_change_url || '/cart/change.js',
    update: window.routes?.cart_update_url || '/cart/update.js'
  };

  function fetchCart() {
    return fetch(`${TB_CART_URLS.cart}.js`, {
      headers: { 'Content-Type': 'application/json' }
    }).then((r) => {
      if (!r.ok) throw new Error('cart.js fetch failed');
      return r.json();
    });
  }

  function cartAdd(items) {
    return fetch(TB_CART_URLS.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    }).then(async (r) => {
      const data = await r.json().catch(() => null);
      if (!r.ok) {
        throw new Error(
          data && (data.description || data.message)
            ? (data.description || data.message)
            : 'cart/add.js failed'
        );
      }
      return data;
    });
  }

  function cartChange(line, quantity) {
    return fetch(TB_CART_URLS.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    }).then(async (r) => {
      const data = await r.json().catch(() => null);
      if (!r.ok) {
        throw new Error(
          data && (data.description || data.message)
            ? (data.description || data.message)
            : 'cart/change.js failed'
        );
      }
      return data;
    });
  }

  function cartUpdate(updates) {
    return fetch(TB_CART_URLS.update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }).then(async (r) => {
      const data = await r.json().catch(() => null);
      if (!r.ok) {
        throw new Error(
          data && (data.description || data.message)
            ? (data.description || data.message)
            : 'cart/update.js failed'
        );
      }
      return data;
    });
  }

  function removeProductFromCart(productId) {
    return fetchCart().then((cart) => {
      const updates = {};
      let found = false;

      cart.items.forEach((item) => {
        if (item.product_id.toString() === productId.toString()) {
          updates[item.key] = 0;
          found = true;
        }
      });

      if (!found) return cart;
      return cartUpdate(updates);
    });
  }

  function removeFreeItemsFromCart() {
    return fetchCart().then((cart) => {
      const updates = {};
      let found = false;

      cart.items.forEach((item) => {
        if (item.properties && item.properties['_tb_free']) {
          updates[item.key] = 0;
          found = true;
        }
      });

      if (!found) return cart;
      return cartUpdate(updates);
    });
  }

  function refreshDrawer() {
    const drawer = document.querySelector('.drawer__inner');
    if (!drawer) return Promise.resolve();

    return fetch(`${TB_CART_URLS.cart}?section_id=cart-drawer`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector('.drawer__inner');
        const dst = document.querySelector('.drawer__inner');
        if (src && dst) dst.replaceWith(src);
      })
      .catch((e) => log('refreshDrawer failed', e));
  }

  function refreshCartFooter() {
    const footer = document.getElementById('main-cart-footer');
    if (!footer) return Promise.resolve();

    const sectionId = footer.dataset.id;

    return fetch(`${TB_CART_URLS.cart}?section_id=${sectionId || 'main-cart-footer'}`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const srcContents = doc.querySelector('#main-cart-footer .js-contents');
        const dstContents = document.querySelector('#main-cart-footer .js-contents');

        if (srcContents && dstContents) {
          dstContents.replaceWith(srcContents);
        } else {
          const src = doc.getElementById('main-cart-footer') || doc.querySelector('.shopify-section');
          if (src && footer) footer.replaceWith(src);
        }
      })
      .catch((e) => log('refreshCartFooter failed', e));
  }

  function refreshMainCartItems() {
    const main = document.getElementById('main-cart-items');
    if (!main) return Promise.resolve();

    const sectionId = main.dataset.id;

    return fetch(`${TB_CART_URLS.cart}?section_id=${sectionId || 'main-cart-items'}`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const srcContents = doc.querySelector('#main-cart-items .js-contents');
        const dstContents = document.querySelector('#main-cart-items .js-contents');

        if (srcContents && dstContents) {
          dstContents.replaceWith(srcContents);
        } else {
          const src = doc.getElementById('main-cart-items') || doc.querySelector('.shopify-section');
          if (src && main) main.replaceWith(src);
        }
      })
      .catch((e) => log('refreshMainCartItems failed', e));
  }

  function refreshCartBubble() {
    return fetch(`${TB_CART_URLS.cart}?section_id=cart-icon-bubble`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.getElementById('shopify-section-cart-icon-bubble');
        const dst = document.getElementById('cart-icon-bubble');
        if (src && dst) dst.innerHTML = src.innerHTML;
      })
      .catch((e) => log('refreshCartBubble failed', e));
  }

function fullRefresh() {
  return Promise.all([
    refreshDrawer(),
    refreshCartBubble(),
    refreshMainCartItems(),
    refreshCartFooter()
  ]).then(() => {
    bindInsuranceToggle();
    bindInsuranceAcknowledgement();
    bindFreeItemsForm();
  });
}
  let _cfg = null;

  function getConfig() {
    if (_cfg) return _cfg;
    const el = document.getElementById('tb-cart-config');
    if (!el) return null;

    _cfg = {
      insuranceEnabled: el.dataset.insuranceEnabled === 'true',
      insurancePct: parseFloat(el.dataset.insurancePct || '0'),
      insuranceProductId: el.dataset.insuranceProductId || '',
      insuranceVariantId: el.dataset.insuranceVariantId || '',
      freeEnabled: el.dataset.freeEnabled === 'true',
      freeMinimumCents: parseInt(el.dataset.freeMinimum || '0', 10),
      freeHatProductId: el.dataset.freeHatId || '',
      freeShirtProductId: el.dataset.freeShirtId || ''
    };

    return _cfg;
  }

  const Insurance = {
    calcBase(cartItems, cfg) {
      return cartItems.reduce((total, item) => {
        const pid = item.product_id.toString();
        if (pid === cfg.insuranceProductId) return total;
        if (item.properties && item.properties['_tb_free']) return total;
        return total + item.final_line_price;
      }, 0);
    },

    calcAmountCents(cartItems, cfg) {
      const base = this.calcBase(cartItems, cfg);
      return Math.round(base * (cfg.insurancePct / 100));
    },

    isInCart(cartItems, cfg) {
      return cartItems.some((item) => item.product_id.toString() === cfg.insuranceProductId);
    },

    getLineIndex(cartItems, cfg) {
      const idx = cartItems.findIndex((item) => item.product_id.toString() === cfg.insuranceProductId);
      return idx >= 0 ? idx + 1 : null;
    },

    getCurrentQty(cartItems, cfg) {
      const item = cartItems.find((line) => line.product_id.toString() === cfg.insuranceProductId);
      return item ? item.quantity : 0;
    },

    upsert(cfg) {
      return fetchCart().then((cart) => {
        const cents = this.calcAmountCents(cart.items, cfg);
        if (cents <= 0) throw new Error('Insurance amount is zero for this cart.');

        if (this.isInCart(cart.items, cfg)) {
          const line = this.getLineIndex(cart.items, cfg);
          return cartChange(line, cents);
        }

        return cartAdd([
          {
            id: parseInt(cfg.insuranceVariantId, 10),
            quantity: cents
          }
        ]);
      });
    },

    remove(cfg) {
      return removeProductFromCart(cfg.insuranceProductId);
    },

    recalcIfPresent(cfg) {
      if (!cfg || !cfg.insuranceEnabled) return Promise.resolve();

      return fetchCart().then((cart) => {
        if (!this.isInCart(cart.items, cfg)) return cart;

        const needed = this.calcAmountCents(cart.items, cfg);
        const current = this.getCurrentQty(cart.items, cfg);

        if (needed <= 0) {
          log('Insurance recalc: base is now $0, removing insurance');
          return this.remove(cfg);
        }

        if (needed !== current) {
          const lineIdx = this.getLineIndex(cart.items, cfg);
          log(`Insurance recalc: qty ${current} → ${needed}`);
          return cartChange(lineIdx, needed);
        }

        return cart;
      });
    }
  };

  const FreeItems = {
    calcSubtotal(cartItems, cfg) {
      return cartItems.reduce((total, item) => {
        const pid = item.product_id.toString();
        if (pid === cfg.insuranceProductId) return total;
        if (item.properties && item.properties['_tb_free']) return total;
        return total + item.final_line_price;
      }, 0);
    },

    thresholdMet(cartItems, cfg) {
      return this.calcSubtotal(cartItems, cfg) >= cfg.freeMinimumCents;
    },

    hatInCart(cartItems) {
      return cartItems.some((item) => item.properties && item.properties['_tb_free'] === 'hat');
    },

    shirtInCart(cartItems) {
      return cartItems.some((item) => item.properties && item.properties['_tb_free'] === 'shirt');
    },

    syncEligibility(cfg) {
      return fetchCart().then((cart) => {
        const qualifies = this.thresholdMet(cart.items, cfg);
        const hasFreeItems = this.hatInCart(cart.items) || this.shirtInCart(cart.items);

        if (qualifies || !hasFreeItems) return cart;
        return removeFreeItemsFromCart();
      });
    },

    add(hatVariantId, shirtVariantId, cfg) {
      const items = [];

      if (hatVariantId) {
        items.push({
          id: parseInt(hatVariantId, 10),
          quantity: 1,
          properties: {
            '_tb_free': 'hat',
            '_tb_free_label': 'Complimentary Hat',
            '_tb_gift_type': 'free-promo'
          }
        });
      }

      if (shirtVariantId) {
        items.push({
          id: parseInt(shirtVariantId, 10),
          quantity: 1,
          properties: {
            '_tb_free': 'shirt',
            '_tb_free_label': 'Complimentary Shirt',
            '_tb_gift_type': 'free-promo'
          }
        });
      }

      if (!items.length) return Promise.resolve();

      return fetchCart().then((cart) => {
        if (!this.thresholdMet(cart.items, cfg)) {
          throw new Error('Free gift threshold is no longer met.');
        }

        return removeFreeItemsFromCart().then(() => cartAdd(items));
      });
    }
  };

function bindInsuranceToggle() {
  const cfg = getConfig();
  if (!cfg || !cfg.insuranceEnabled) return;

  document.querySelectorAll('.tb-insurance-toggle:not([data-tb-bound])').forEach((btn) => {
    btn.dataset.tbBound = 'true';

    btn.addEventListener('click', function () {
      const wrapper = this.closest('.tb-insurance-wrapper');
      if (!wrapper) return;

      const errorEl = wrapper.querySelector('.tb-insurance-error');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      const isOptedIn = wrapper.dataset.insuranceOptedIn === 'true';
      const originalText = this.textContent;

      this.disabled = true;
      this.textContent = 'Updating…';

      const action = isOptedIn ? Insurance.remove(cfg) : Insurance.upsert(cfg);

      action
        .then(() => fullRefresh())
        .catch((err) => {
          log('Insurance toggle error', err);

          this.disabled = false;
          this.textContent = originalText;

          if (errorEl) {
            errorEl.textContent = err && err.message
              ? err.message
              : 'Unable to update order protection.';
            errorEl.hidden = false;
          }
        });
    });
  });
}
function saveInsuranceAcknowledgement(checked) {
  return fetch(TB_CART_URLS.update, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        'Insurance waiver acknowledged': checked ? 'Yes' : ''
      }
    })
  }).then(async (r) => {
    const data = await r.json().catch(() => null);
    if (!r.ok) {
      throw new Error(
        data && (data.description || data.message)
          ? (data.description || data.message)
          : 'Unable to save insurance acknowledgement.'
      );
    }
    return data;
  });
}

function checkoutButtons() {
  return Array.from(document.querySelectorAll(
    '#CartDrawer-Checkout, .cart__checkout-button[name="checkout"], button[name="checkout"], input[name="checkout"]'
  ));
}

function syncInsuranceAcknowledgementState() {
  const wrapper = document.querySelector('.tb-insurance-wrapper');
  if (!wrapper) return;

  const insuranceOptedIn = wrapper.dataset.insuranceOptedIn === 'true';
  const checkbox = wrapper.querySelector('.tb-insurance-ack__checkbox');
  const ackError = wrapper.querySelector('.tb-insurance-ack-error');
  const buttons = checkoutButtons();

  if (ackError) {
    ackError.hidden = true;
    ackError.textContent = '';
  }

  const acknowledged = checkbox ? checkbox.checked : false;
  const allowCheckout = insuranceOptedIn || acknowledged;

  buttons.forEach((btn) => {
    btn.disabled = !allowCheckout;
    btn.classList.toggle('tb-checkout-blocked', !allowCheckout);
  });
}

function bindInsuranceAcknowledgement() {
  const wrapper = document.querySelector('.tb-insurance-wrapper');
  if (!wrapper) return;

  const checkbox = wrapper.querySelector('.tb-insurance-ack__checkbox');
  if (!checkbox || checkbox.dataset.tbBound === 'true') {
    syncInsuranceAcknowledgementState();
    return;
  }

  checkbox.dataset.tbBound = 'true';

  checkbox.addEventListener('change', function () {
    const ackError = wrapper.querySelector('.tb-insurance-ack-error');
    if (ackError) {
      ackError.hidden = true;
      ackError.textContent = '';
    }

    saveInsuranceAcknowledgement(this.checked)
      .then(() => {
        syncInsuranceAcknowledgementState();
      })
      .catch((err) => {
        this.checked = !this.checked;
        syncInsuranceAcknowledgementState();

        if (ackError) {
          ackError.textContent = err && err.message
            ? err.message
            : 'Unable to save acknowledgement.';
          ackError.hidden = false;
        }
      });
  });

  const buttons = checkoutButtons();
  buttons.forEach((btn) => {
    if (btn.dataset.tbAckBound === 'true') return;
    btn.dataset.tbAckBound = 'true';

    btn.addEventListener('click', function (e) {
      const isOptedIn = wrapper.dataset.insuranceOptedIn === 'true';
      const checked = checkbox.checked;
      const ackError = wrapper.querySelector('.tb-insurance-ack-error');

      if (!isOptedIn && !checked) {
        e.preventDefault();
        e.stopPropagation();

        if (ackError) {
          ackError.textContent = 'Please acknowledge responsibility or add order protection before checkout.';
          ackError.hidden = false;
        }
      }
    });
  });

  syncInsuranceAcknowledgementState();
}

  function bindFreeItemsForm() {
    const cfg = getConfig();
    if (!cfg || !cfg.freeEnabled) return;

    document.querySelectorAll('.tb-free-items-form:not([data-tb-bound])').forEach((form) => {
      form.dataset.tbBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const hatSelect = form.querySelector('.tb-hat-select');
        const shirtSelect = form.querySelector('.tb-shirt-select');
        const errorEl = form.querySelector('.tb-free-error');
        const submitBtn = form.querySelector('.tb-free-submit');
        const defaultBtnText = submitBtn ? submitBtn.textContent : 'Add Free Items to Cart';

        const hatVal = hatSelect ? hatSelect.value : '';
        const shirtVal = shirtSelect ? shirtSelect.value : '';

        if (!hatVal) {
          if (errorEl) {
            errorEl.textContent = 'Please choose a hat color.';
            errorEl.hidden = false;
          }
          if (hatSelect) hatSelect.focus();
          return;
        }

        if (!shirtVal) {
          if (errorEl) {
            errorEl.textContent = 'Please choose a shirt size.';
            errorEl.hidden = false;
          }
          if (shirtSelect) shirtSelect.focus();
          return;
        }

        if (errorEl) {
          errorEl.textContent = '';
          errorEl.hidden = true;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding…';
        }

        FreeItems.add(hatVal, shirtVal, cfg)
          .then(() => Insurance.recalcIfPresent(cfg))
          .then(() => fullRefresh())
          .catch((err) => {
            log('Free items add error', err);
            if (errorEl) {
              errorEl.textContent = err && err.message ? err.message : 'Something went wrong. Please try again.';
              errorEl.hidden = false;
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = defaultBtnText;
            }
          });
      });
    });
  }

  function bindCheckoutGate() {
    const cfg = getConfig();
    if (!cfg || !cfg.freeEnabled) return;

    document.querySelectorAll('#checkout:not([data-tb-bound]), #CartDrawer-Checkout:not([data-tb-bound])').forEach((btn) => {
      btn.dataset.tbBound = 'true';

      btn.addEventListener('click', function (e) {
        const wrapper = document.querySelector('.tb-free-items-wrapper');
        if (!wrapper) return;

        const thresholdMet = wrapper.dataset.thresholdMet === 'true';
        const hatAdded = wrapper.dataset.hatAdded === 'true';
        const shirtAdded = wrapper.dataset.shirtAdded === 'true';

        if (thresholdMet && (!hatAdded || !shirtAdded)) {
          e.preventDefault();
          e.stopImmediatePropagation();

          let warningEl = document.getElementById('tb-checkout-warning');
          if (!warningEl) {
            warningEl = document.createElement('p');
            warningEl.id = 'tb-checkout-warning';
            warningEl.className = 'tb-checkout-warning';
            warningEl.setAttribute('role', 'alert');
            btn.parentNode.insertBefore(warningEl, btn);
          }

          warningEl.textContent = 'Please add your complimentary hat and shirt before checkout.';
          warningEl.hidden = false;
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, true);
    });
  }

  function listenForCartUpdates() {
    const runCartSync = () => {
      const cfg = getConfig();
      if (!cfg) return Promise.resolve();

      return Promise.resolve()
        .then(() => Insurance.recalcIfPresent(cfg))
        .then(() => FreeItems.syncEligibility(cfg))
        .then(() => fullRefresh())
        .catch((err) => log('Cart sync error', err));
    };

    document.addEventListener('cart:updated', runCartSync);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, runCartSync);
    }
  }

function init() {
  if (!document.getElementById('tb-cart-config')) return;
  _cfg = null;
  bindInsuranceToggle();
  bindInsuranceAcknowledgement();
  bindFreeItemsForm();
  bindCheckoutGate();
}

  const _observer = new MutationObserver(debounceInit);
  let _debounceTimer;

  function debounceInit() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(init, 120);
  }

  _observer.observe(document.body, { childList: true, subtree: true });
  listenForCartUpdates();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TBCart = { Insurance, FreeItems, fetchCart, fullRefresh };
})();
